export enum RosterCodes{
  Day = 4,
  Night = 5,
  FIA = 15,
  FIP = 16,
  FOA = 17,
  FOP = 18,
  DIA = 19,
  DIP = 20,
  DOA = 21,
  DOP = 22,
  SD = 14,
  RR = 7,
  AL = 9,
  PH = 24,
  TOIL = 1,
  PO = 2
}